import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { isLinkItem } from '../utils/utils';
import LinkItem from './link-item';
import styles from './styles.css.js';
var ItemElement = function (_a) {
    var _b;
    var item = _a.item, disabled = _a.disabled, onItemActivate = _a.onItemActivate, highlighted = _a.highlighted, last = _a.last, hasCategoryHeader = _a.hasCategoryHeader;
    var isAllowedLink = isLinkItem(item);
    var onClick = function (event) {
        !isAllowedLink && event.preventDefault();
        !disabled && onItemActivate(item, event);
    };
    var itemRef = useRef(null);
    useEffect(function () {
        if (highlighted && itemRef.current) {
            itemRef.current.focus();
        }
    }, [highlighted]);
    return (React.createElement("li", { className: clsx(styles['item-element'], (_b = {},
            _b[styles.highlighted] = highlighted,
            _b[styles.disabled] = disabled,
            _b[styles.last] = last,
            _b[styles['has-category-header']] = hasCategoryHeader,
            _b[styles['item-link']] = isAllowedLink,
            _b)), role: "menuitem", "data-testid": item.id, "data-description": item.description, "aria-disabled": disabled ? 'true' : undefined, 
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: disabled ? undefined : highlighted ? 0 : -1, onClick: isAllowedLink ? undefined : onClick, ref: isAllowedLink ? undefined : itemRef }, isAllowedLink ? React.createElement(LinkItem, { item: item, disabled: disabled, itemRef: itemRef, onClick: onClick }) : item.text));
};
export default ItemElement;
//# sourceMappingURL=index.js.map